<a #badge [href]="user.profileUrl()">{{user}}</a>
